import { FrequencyGroups } from "app/services/api/types/medications/enums/FrequencyEnum";
import { useCallback, useMemo } from "react";

interface props {
  activeFilters?: string[];
  onChangeFilters?: (filters: string[]) => void;
}
export function useMedicationFilterGroups({
  activeFilters,
  onChangeFilters,
}: props) {
  const activeFilterGroups = useMemo(
    () =>
      (activeFilters ?? []).filter((shift) => FrequencyGroups.includes(shift)),
    [activeFilters],
  );

  const handlePress = useCallback(
    (option: string) => {
      const newActiveFilters = activeFilterGroups.includes(option)
        ? activeFilterGroups.filter((item) => item !== option)
        : [...activeFilterGroups, option];

      onChangeFilters?.(newActiveFilters);
    },
    [activeFilterGroups, onChangeFilters],
  );

  return {
    activeFilterGroups,
    handlePress,
  };
}
